import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IrisUserTimePipe } from '@iris/common/modules/time';
import { ValidationMessageResolver } from '@ngx-strakit/validation';

@Injectable()
export class SkMaxDatetimeValidationMessageResolver implements ValidationMessageResolver<{ max: unknown }> {
  private readonly translate = inject(TranslateService);
  private readonly userTimePipe = inject(IrisUserTimePipe);
  readonly errorCode = 'matDatepickerMax';

  getMessage(error?: { max: unknown }): string {
    return this.translate.instant('label.validation.max', { value: this.userTimePipe.transform(error?.max) });
  }
}
